import React, { useEffect } from 'react'
import { get, isEmpty } from 'lodash'
import { connect, useDispatch } from 'react-redux'
import { GET_SUB_SCRIPTION } from '../../redux/actions/type'
import { Views } from '../../views'


const Success = ({ keycloak }) => {

    const dispatch = useDispatch()
    const { Success } = Views

    useEffect(() => {
        if (!isEmpty(keycloak) && !keycloak.authenticated) {
            window.location.href = '/portal'
        }
    }, [keycloak])

    useEffect(() => {
        if (!isEmpty(keycloak) && keycloak.authenticated) {
            dispatch({
                type: GET_SUB_SCRIPTION
            })
        }
    }, [dispatch, keycloak])


    return (
        !isEmpty(keycloak) && keycloak.authenticated ? (
            <Success />
        ) : null
    )
}

const mapStateToProps = state => ({
    keycloak: get(state, "keycloak", "")
})
export default connect(mapStateToProps, {})(Success)